export default __webpack_public_path__ + "static/media/loading-64px.10d2e2fa.svg";